import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import moment from 'moment'
import { socket } from '../../../../index';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';

export const statisticLoadCustomersStart = () => {
    return {
        type: 'STATISTIC|REPORT_LOAD_CUSTOMERS_START',
        loading: true
    };
};

export const statisticLoadCustomersSuccess = (data) => {
    return {
        type: 'STATISTIC|REPORT_LOAD_CUSTOMERS_SUCCESS',
        loading: false,
        data: data

    };
};

export const statisticLoadCustomersFail = () => {
    return {
        type: 'STATISTIC|REPORT_LOAD_CUSTOMERS_FAIL',
        loading: false
    };
};

export const loadCustomers = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(statisticLoadCustomersStart())
            let res = await rest.post('/customers/list', { ...id, listAll: true });
            if (res.data && res.data.succeeded) {
                const customers = { list: [], customerObj: {} }
                for (var customer of res.data.result.data) {
                    customers.list.push({ value: customer.CustomerID, label: `${customer.Name}` });
                    customers.customerObj[customer.CustomerID] = customer.Name;
                }
                dispatch(statisticLoadCustomersSuccess(customers))

                return customers;
            }
            else {
                dispatch(statisticLoadCustomersFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            dispatch(statisticLoadCustomersFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const statisticLoadOrdersStart = () => {
    return {
        type: 'STATISTIC|ORDER_LOAD_CUSTOMERS_START',
        loading: true
    };
};

export const statisticLoadOrdersSuccess = (data) => {
    return {
        type: 'STATISTIC|ORDER_LOAD_CUSTOMERS_SUCCESS',
        loading: false,
        data: data

    };
};

export const statisticLoadOrdersFail = () => {
    return {
        type: 'STATISTIC|ORDER_LOAD_CUSTOMERS_FAIL',
        loading: false
    };
};

export const loadOrders = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(statisticLoadOrdersStart())
            let res = await rest.post('/palettes/order/list', { ...id, listAll: true });
            if (res.data && res.data.succeeded) {
                const orders = { list: [], orderObj: {} }
                for (var order of res.data.result.data) {
                    orders.list.push({ value: order.OrderID, label: order.Name });
                    orders.orderObj[order.OrderID] = order.Name;
                }
                dispatch(statisticLoadOrdersSuccess(orders))
                return orders;
            }
            else {
                dispatch(statisticLoadOrdersFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            dispatch(statisticLoadOrdersFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const statisticLoadTransportColliesStart = () => {
    return {
        type: 'STATISTIC|TRANSPORT_COLLIES_LOAD_CUSTOMERS_START',
        loading: true
    };
};

export const statisticLoadTransportColliesSuccess = (data) => {
    return {
        type: 'STATISTIC|TRANSPORT_COLLIES_LOAD_CUSTOMERS_SUCCESS',
        loading: false,
        data: data
    };
};

export const statisticLoadTransportColliesFail = () => {
    return {
        type: 'STATISTIC|TRANSPORT_COLLIES_LOAD_CUSTOMERS_FAIL',
        loading: false
    };
}

export const loadTransportCollies = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(statisticLoadOrdersStart())
            let res = await rest.post('/palettes/transportColli/list', { ...id, listAll: true });
            if (res.data && res.data.succeeded) {
                const transportCollies = { list: [], transportColliObj: {} }
                for (var transportColli of res.data.result.data) {
                    transportCollies.list.push({ value: transportColli.TransportColliID, label: `${transportColli.Name} (${transportColli.TransportColliInventoryID})` });
                    transportCollies.transportColliObj[transportColli.TransportColliID] = `${transportColli.Name} (${transportColli.TransportColliInventoryID})`;
                }
                dispatch(statisticLoadTransportColliesSuccess(transportCollies))
                return transportCollies;
            }
            else {
                dispatch(statisticLoadTransportColliesFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            dispatch(statisticLoadTransportColliesFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const statisticLoadColliesStart = () => {
    return {
        type: 'STATISTIC|COLLIS_LOAD_CUSTOMERS_START',
        loading: true
    };
};

export const statisticLoadColliesSuccess = (data) => {
    return {
        type: 'STATISTIC|COLLIS_LOAD_CUSTOMERS_SUCCESS',
        loading: false,
        data: data

    };
};

export const statisticLoadColliesFail = () => {
    return {
        type: 'STATISTIC|COLLIS_LOAD_CUSTOMERS_FAIL',
        loading: false
    };
}

export const loadCollies = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(statisticLoadColliesStart())
            let res = await rest.post('/colli/list', { ...id, listAll: true });
            if (res.data && res.data.succeeded) {
                const collies = { list: [], colliesObj: {} }
                for (var colli of res.data.result.data) {
                    collies.list.push({ value: colli.ColliID, label: `${colli.Name} (${colli.ColliInventoryID})` });
                    collies.colliesObj[colli.ColliID] = `${colli.Name} (${colli.ColliInventoryID})`;
                }
                dispatch(statisticLoadColliesSuccess(collies))
                return collies;
            }

            else {
                dispatch(statisticLoadUsersFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }

        } catch (error) {
            dispatch(statisticLoadColliesFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const statisticLoadUsersStart = () => {
    return {
        type: 'STATISTIC|USERS_LOAD_CUSTOMERS_START',
        loading: true
    };
};

export const statisticLoadUsersSuccess = (data) => {
    return {
        type: 'STATISTIC|USERS_LOAD_CUSTOMERS_SUCCESS',
        loading: false,
        data: data

    };
};

export const statisticLoadUsersFail = () => {
    return {
        type: 'STATISTIC|USERS_LOAD_CUSTOMERS_FAIL',
        loading: false
    };
}
export const loadUsers = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(statisticLoadUsersStart())
        try {
            let res = await rest.post('/users/list', { ...id, listAll: true });
            if (res.data && res.data.succeeded) {
                const users = { list: [], usersObj: {} }
                for (var user of res.data.result.data) {
                    users.list.push({ value: user.UserID, label: user.Username });
                    users.usersObj[user.UserID] = user.Username;
                }
                dispatch(statisticLoadUsersSuccess(users))
                return users;
            }

            else {
                dispatch(statisticLoadUsersFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }

        } catch (error) {
            dispatch(statisticLoadUsersFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}
// Create CRUD action creator
export const statisticReportStart = () => {
    return {
        type: 'STATISTIC|STATISTIC_REPORT_START',
        loading: true
    };
};
export const statisticReportSuccess = (data, column) => {
    return {
        type: 'STATISTIC|STATISTIC_REPORT_SUCCESS',
        loading: false,
        data: data,
    };
};
export const statisticReportFail = () => {
    return {
        type: 'STATISTIC|STATISTIC_REPORT_FAIL',
        loading: false
    };
};
// custom functions
export const listStatisticReport = (id) => {
    let token = localStorage.getItem('SESSION');

    const rest = getAxiosInstance();
    return async (dispatch, getState) => {
        try {
            const store = getState();
            const users = store.statistic.report.users.usersObj;

            dispatch(statisticReportStart())
            let res = await rest.post('/statistics/get-report', { ...id, Token: token });
            if (res.data && res.data.succeeded) {
                let reports = {}
                for (var key of res.data.result.data) {
                    if (!reports.hasOwnProperty(users[key.CreatedBy])) {
                        reports[users[key.CreatedBy]] = {
                            [moment(`${key.CreatedAt}`).format('MM-DD-YYYY')]: key.Products,
                            [moment(`${key.CreatedAt}`).format('w/YY')]: key.Products,
                            [moment(`${key.CreatedAt}`).format('YYYY')]: key.Products,
                            [moment(`${key.CreatedAt}`).format('MMMM/YY')]: key.Products,
                            Total: key.Products
                        }
                    }
                    else {
                        reports[users[key.CreatedBy]] = {
                            ...reports[users[key.CreatedBy]],
                            [moment(`${key.CreatedAt}`).format('MM-DD-YYYY')]: (reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('MM-DD-YYYY')] === undefined ? key.Products : reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('MM-DD-YYYY')] + key.Products),
                            [moment(`${key.CreatedAt}`).format('w/YY')]: (reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('w/YY')] === undefined ? key.Products : reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('w/YY')] + key.Products),
                            [moment(`${key.CreatedAt}`).format('YYYY')]: (reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('YYYY')] === undefined ? key.Products : reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('YYYY')] + key.Products),
                            [moment(`${key.CreatedAt}`).format('MMMM/YY')]: (reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('MMMM/YY')] === undefined ? key.Products : reports[users[key.CreatedBy]][moment(`${key.CreatedAt}`).format('MMMM/YY')] + key.Products),
                            Total: key.Products + reports[users[key.CreatedBy]]['Total']
                        }
                    }
                }
                dispatch(statisticReportSuccess(reports))
                return reports;
            }
            else {
                dispatch(statisticReportFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }

        } catch (error) {
            dispatch(statisticReportFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const reportColumnsStart = () => {
    return {
        type: 'REPORT|REPORT_COLUMNS_START',
    };
};
export const reportColumnsSuccess = (column) => {
    return {
        type: 'REPORT|REPORT_COLUMNS_SUCCESS',
        column: column
    };
};
export const reportColumnsFail = () => {
    return {
        type: 'REPORT|REPORT_COLUMNS_FAIL',
    };
};

export const GetColumns = (data) => {
    var columnArray = [{
        title: 'User name',
        field: 'UserName',
        emptyValue: '/',
    },
    {
        title: 'Total',
        field: 'Total',
        emptyValue: 0,
        hidden: false
    }]

    var currentDay = moment(data.dayStart)
    var lastDate = moment(data.dayEnd);
    const diffUnitOfTime = `${data.type}s`;
    return async (dispatch) => {
        try {
            dispatch(reportColumnsStart())
            while (moment(lastDate).diff(currentDay, diffUnitOfTime) >= 0) {
                switch (diffUnitOfTime) {
                    case 'days':
                        columnArray.push({
                            title: moment(`${currentDay}`).format('MM-DD-YYYY'),
                            field: moment(`${currentDay}`).format('MM-DD-YYYY'),
                            emptyValue: 0,
                            hidden: false
                        })
                        break;
                    case 'weeks':
                        columnArray.push({
                            title: moment(`${currentDay}`).format('w/YY'),
                            field: moment(`${currentDay}`).format('w/YY'),
                            emptyValue: 0,
                            hidden: false
                        })
                        break;
                    case 'months':
                        if (moment(`${currentDay}`).format('MMMM/YY') !== moment(moment(data.dayEnd).add(1, diffUnitOfTime)).format('MMMM/YY')) {
                            columnArray.push({
                                title: moment(`${currentDay}`).format('MMMM/YY'),
                                field: moment(`${currentDay}`).format('MMMM/YY'),
                                emptyValue: 0,
                                hidden: false
                            })
                        }
                        break;
                    case 'years':


                        if (moment(`${currentDay}`).format('YYYY') <= moment(`${data.dayEnd}`).format('YYYY')) {

                            columnArray.push({
                                title: moment(`${currentDay}`).format('YYYY'),
                                field: moment(`${currentDay}`).format('YYYY'),
                                emptyValue: 0,
                                hidden: false
                            })
                        }
                        break;
                    default:
                        break;
                }
                const currentEnd = moment(moment(currentDay).add(1, diffUnitOfTime)).format('YYYY-MM-DD');
                currentDay = currentEnd;
            }
            dispatch(reportColumnsSuccess(columnArray))
            return columnArray;

        } catch (error) {
            dispatch(reportColumnsFail());
            snackActions.snackBar({
                message: `${"Can not filter "}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }



    }


}

export const downloadExcelReport = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/statistics/export-assets', { ...params, SocketID: socket.id.split('#')[1] });
            if (res?.data?.result?.data?.RedisTopic) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    let file = await dispatch(actionDownload.downloadStatistic(params.ActiveCustomerID, msg.FilePath, msg.FileName));
                    if (file) {
                        downloadFile(file, msg.FileName);
                        return true;
                    }
                })
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Download failed '}`,
                options: {
                    variant: 'error'
                }
            });
        }
    }
};
